<template>
	<div>
		<div>
			<div class="stu-msg-box">
				<div class="pic-box head-pic">
					<van-image v-if="stuMsg.avatar" width="2rem" height="2rem" fit="cover" :src="stuMsg.avatar + '?imageView2/1/w/' + 200 + '/h/' + 200" />
				</div>
				<div class="stu-msg-item">
					<p v-text="stuMsg.name"></p>
					<p v-text="stuMsg.deptName"></p>
				</div>
			</div>
			<div class="stu-temp-box">
				<van-cell is-link="" @click="tempTimeShow=true">
					<div class="temp-time-box">
						<p>测温时间</p>
						<p v-text="currentDateShow"></p>
					</div>
				</van-cell>
				<van-popup v-model="tempTimeShow" position="bottom" :style="{ height: '50%' }">
					<van-datetime-picker v-model="currentDate" type="datetime" :min-date="minDate" :max-date="maxDate" @confirm="confirm()"
					 @cancel="show=false" />
				</van-popup>

				<van-form>
					<van-cell is-link @click="tempNumShow=true" :class="{ 'bg-green': isNormal }">
						<div class="temp-time-box">
							<p :class="{ 'color-white': isNormal }">体温</p>
                            <p :class="{'color-white': isNormal}" v-text="stuTemp"></p>
                        </div>
					</van-cell>
				</van-form>

                <van-popup v-model="tempNumShow" position="bottom">
                    <van-picker show-toolbar title="选择温度" :columns="tempList" @confirm='tempSelectConfirm' @cancel="tempNumShow = false" />
                </van-popup>

				<div class="drop-box">
					<p class="drop-lable">是否有异常表现</p>
					<van-dropdown-menu class="drop-item">
						<van-dropdown-item v-model="abnormalStatus" :options="abnormalStatusList" />
					</van-dropdown-menu>
				</div>
				<p class="descripation-title">疫情表现描述:</p>
				<p class="descripation-title" v-html="abnormalDescribe"></p>
			</div>
			<div class="submit-btn-box">
                <van-button type="primary" class="submit-btn" @click='goBack()'>返回</van-button>
				<van-button type="primary" class="submit-btn" :loading='submitLoding' loading-text="正在提交..." @click='submitRecord'>提交</van-button>
				<van-button type="primary" class="submit-btn" :disabled="isRecordDone" @click='nextStu'>下一个({{n+1}}/{{all}})</van-button>
			</div>
			<bottom-tab></bottom-tab>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import commonObj from '../../common/common.js'
	import api from '../../http/api.js'

    import {
        DropdownMenu,
        DropdownItem,
        Form,
        Field,
        Button,
        Toast,
        Image,
        Dialog
    } from 'vant';
	import {

	} from 'vant'

	Vue.use(DropdownMenu);
	Vue.use(DropdownItem)
	Vue.use(Form)
	Vue.use(Field)
	Vue.use(Button)
	Vue.use(Toast)
    Vue.use(Image)
    Vue.use(Dialog)

	export default {
		data() {
			return {
				stuMsg: {},
				stuTemp: '', // 体温
				abnormalStatusList: [{
						text: '是',
						value: 1
					},
					{
						text: '否',
						value: 2
					}
				],
                permsList: JSON.parse(window.localStorage.getItem('permsList')),
				abnormalStatus: 2, // 1是  2否
				abnormalDescribe: '1.近14天是否到过中高风险地区<br/>2.近14天有没有接触过来自中高风险地区的亲属,朋友<br/>3.近14天是否接触过可疑病例及发热病人', //异常表现描述
				submitLoding: false, // 按钮是否加载
				n: 0, // 当前录入学生数
				all: 0, // 学生总数
				isRecordDone: false, // 是否录入到最后一个
				stuList: [],
				submitterId: window.localStorage.getItem('uid'),
                tempList: [{
                    values: ['34', '35', '36', '37', '38', '39'],
                    defaultIndex: 2
                },
                    {
                        values: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
                        defaultIndex: 0
                    }
                ],
				// 1.1
				currentDateShow: this.formatDate(new Date(), "yyyy/MM/dd HH:mm"), //当前时间
				tempTimeShow: false, //选择时间插件开关 
				currentDate: new Date(),
				minDate: new Date(2019, 0, 1),
				maxDate: new Date(2030, 11, 31),
				tempNumShow: false, // 温度选择器开关

                deptId: undefined,
                nowUserId: undefined,
                isClassTemp: false, // 是否为班级录入  （班级录入、宿舍录入）

                maxNTemp: window.localStorage.getItem('maxTemp'), // 最大体温
                minNTemp: window.localStorage.getItem('minTemp'), // 最小体温
                isNormal: false,
                stuTemp_: ''
			}
		},
		methods: {
			pageInit() {
			    let page = this;
				// 获取上个页面传来的班级ID
				if (this.$route.query.type) {
					// 宿舍批量录入
                    this.isClassTemp = false;
					api.getStudentsOfDormroom(this.$route.query.id).then(res => {
						if (res.data.code == 200) {
							this.all = res.data.data.length
							for (let i = 0; i < res.data.data.length; i++) {
								let obj = {
									avatar: res.data.data[i].avatar,
									name: res.data.data[i].studentName,
									deptName: res.data.data[i].depts[0].name,
									id: res.data.data[i].userId
								}
								this.stuList.push(obj)
							}
							this.stuMsg = this.stuList[this.n]
							if (this.n === this.all - 1) {
								this.isRecordDone = true
							}
						} else {
							Toast('获取宿舍成员列表失败' + res.data.msg)
						}
					})
				} else {
				    // 班级录入
                    this.isClassTemp = true;

                    this.deptId = this.$route.query.id;
                    this.nowUserId = this.$route.query.userId;
					let data = JSON.stringify({
						deptId: this.$route.query.id,
						pageNum: 1,
						pageSize: 10000,
						roleIds: [5]
					});
					api.findUserPage(data).then(res => {
						if (res.data.code == 200) {
							this.all = res.data.data.totalSize;
							for (let i = 0; i < res.data.data.content.length; i++) {
								this.stuList.push(res.data.data.content[i])
                                if(this.nowUserId == res.data.data.content[i].id){
                                    this.n = i;
                                }
							}
							this.stuMsg = this.stuList[this.n];
							if (this.n === this.all - 1) {
								this.isRecordDone = true
							}
						} else {
							Toast('获取失败：' + res.data.msg)
						}
					})
				}

				if(commonObj.hasPermission('cust:temp:temperature_gun', this.permsList)){
                    window.onkeydown = function (e) {
                        let key = e.key;
                        if(key == '。'){
                            key = '.'
                        }

                        if(key != 'Enter'){
                            page.stuTemp_ = page.stuTemp_ + key;
                        }else{
                            if(page.stuTemp_.length == 4){
                                page.stuTemp = page.stuTemp_;
                                page.tempIsNormal()
                            }else{
                                page.stuTemp_ = ''
                            }

                        }
                    }
                }
			},
			confirm() {
				this.tempTimeShow = false;
				this.currentDateShow = this.formatDate(this.currentDate, 'yyyy/MM/dd HH:mm')
			},
            goBack(){
                this.$router.go(-1)
            },
			recordDone() {
				this.$router.go(-1)
			},
			nextStu() {
			    this.isNormal = false;
				this.n++;
				this.stuMsg = this.stuList[this.n]
				if (this.n === this.all - 1) {
					this.isRecordDone = true
				}
			},
			submitRecord() {
				let temp = parseFloat(this.stuTemp)
				if (temp && temp > 0) {
					api.reportTemp(this.submitterId, this.stuMsg.id, temp, this.currentDateShow.replace(/\//g, '-') + ":00").then(res => {
						if (res.data.code == 200) {
							Toast('提交成功')
                            this.stuTemp = '';
							this.stuTemp_ = '';
                        } else {
                            this.stuTemp = '';
                            Toast('提交失败：' + res.data.msg)
						}
					});
					if (this.n === this.all - 1) {
						this.isRecordDone = true
						this.recordDone()
					} else {
						this.nextStu()
					}
				} else {
					Toast('输入错误')
				}

			},
            tempSelectConfirm(value) {
                this.stuTemp = value[0] + '.' + value[1]
                this.tempNumShow = false
            },
            tempIsNormal(){
                let page = this;
                if(this.stuTemp > this.maxNTemp || this.stuTemp < this.minNTemp){
                    page.isNormal = false;
                    Dialog.confirm({
                        title: '体温异常',
                        message: '是否继续自动上报'
                    }).then(() => {
                        page.submitRecord()
                    }).catch(() => {
                        page.stuTemp = '';
                        page.stuTemp_ = ''
                    });
                }else{
                    page.isNormal = true;
                    setTimeout(function () {
                        page.submitRecord();
                    }, 400)
                }
            },
			formatDate(date, fmt) {
				date = date == undefined ? new Date() : date;
				date = typeof date == "number" ? new Date(date) : date;
				fmt = fmt || "yyyy-MM-dd HH:mm:ss";
				let obj = {
					y: date.getFullYear(), // 年份，注意必须用getFullYear
					M: date.getMonth() + 1, // 月份，注意是从0-11
					d: date.getDate(), // 日期
					q: Math.floor((date.getMonth() + 3) / 3), // 季度
					w: date.getDay(), // 星期，注意是0-6
					H: date.getHours(), // 24小时制
					h: date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, // 12小时制
					m: date.getMinutes(), // 分钟
					s: date.getSeconds(), // 秒
					S: date.getMilliseconds() // 毫秒
				};
				let week = ["天", "一", "二", "三", "四", "五", "六"];
				for (let i in obj) {
					fmt = fmt.replace(new RegExp(i + "+", "g"), function(m) {
						let val = obj[i] + "";
						if (i == "w") return (m.length > 2 ? "星期" : "周") + week[val];
						for (let j = 0, len = val.length; j < m.length - len; j++)
							val = "0" + val;
						return m.length == 1 ? val : val.substring(val.length - m.length);
					});
				}
				return fmt;
			}
		},
		mounted() {
			this.pageInit()
		},
        beforeDestroy(){
		    window.onkeydown = null
        }

	}



</script>

<style scoped>

    .bg-green{
        background: #07c160;
    }
    .color-white{
        color: white;
    }
	.stu-msg-box {
		display: flex;
		padding-left: 10px;
	}

	.pic-box {
		width: 2rem;
		height: 2rem;
		background-image: url("../../assets/avatar.jpg");
		background-repeat: no-repeat;
		background-size: 2rem 2rem;
	}

	.pic-box img {
		width: 100%;
	}

	.stu-msg-item {
		padding: 0 20px;
		text-align: left;
	}

	.stu-msg-item p:nth-child(1) {
		font-size: 0.5rem;
		margin: 0;
		line-height: 1rem;
	}

	.stu-msg-item p:nth-child(2) {
		margin: 0;
		line-height: 1rem;
	}

	.stu-temp-box {
		border-top: 1px solid rgb(241, 241, 241);
	}

	.drop-box {
		display: flex;
		padding: 0 16px;
		border-top: 1px solid rgb(241, 241, 241);
	}

	.van-hairline--top-bottom::after,
	.van-hairline-unset--top-bottom::after {
		border: none;
	}

	.drop-lable {
		width: 2.5rem;
		text-align: left;
	}

	.drop-item {
		width: calc(100% - 2.5rem);
	}

	.descripation-title {
		padding: 15px 16px;
		border-top: 1px solid rgb(241, 241, 241);
		margin: 0;
	}

	.submit-btn-box {
		position: fixed;
		bottom: 43px;
		left: 0;
		right: 0;
		display: flex;
        justify-content: space-around;
	}

	.submit-btn {
		width: 30%;
		/*background: rgb(25, 136, 203);*/
		/*color: white;*/
	}

	.temp-time-box {
		display: flex;
		justify-content: space-between;
	}

	.temp-time-box p {
		margin: 0;
		line-height: 40px;
		height: 40px;
	}

	.van-cell__right-icon {
		line-height: 40px;
	}
</style>
